import React from "react";
import { ArrowRight } from "lucide-react";
import { JOURNEY_STAGES } from "../data/products";
import { useT } from "../i18n/LanguageContext";

export function JourneyBar({ active, dark = false, testId = "journey-stage-bar" }) {
  const t = useT();
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      {JOURNEY_STAGES.map((s, i) => {
        const isActive = s === active;
        const base = "px-3 py-1 rounded-full text-xs font-medium transition-colors";
        const cls = isActive
          ? "bg-wz-gradient text-[#071A2D]"
          : dark
            ? "bg-white/[0.06] border border-white/15 text-white/70"
            : "bg-white border border-slate-200 text-slate-600";
        return (
          <React.Fragment key={s}>
            <span className={`${base} ${cls}`}>{t(s)}</span>
            {i < JOURNEY_STAGES.length - 1 && (
              <ArrowRight size={12} className={dark ? "text-white/30" : "text-slate-300"} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
